var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3445 6.58874L8.95885 13.0195L1.47884 8.41642C1.32901 8.32618 1.19862 8.20707 1.09522 8.06599C0.991824 7.92491 0.917464 7.7647 0.876524 7.59465C0.835585 7.42459 0.828827 7.24805 0.856692 7.07537C0.884558 6.90269 0.946476 6.73728 1.03883 6.58874C1.21825 6.30964 1.48964 6.10208 1.806 6.00205L19.4624 0.947712C19.6299 0.899614 19.8052 0.885128 19.9782 0.905087C20.1512 0.925047 20.3186 0.979067 20.4707 1.06402C20.6228 1.14897 20.7565 1.26317 20.8642 1.40005C20.972 1.53694 21.0515 1.69378 21.0983 1.86156C21.1662 2.10513 21.1662 2.36257 21.0983 2.60614L15.8522 20.2513C15.8041 20.418 15.7237 20.5737 15.6155 20.7093C15.5073 20.845 15.3734 20.958 15.2214 21.0418C15.0695 21.1256 14.9025 21.1787 14.73 21.1979C14.5576 21.2171 14.3829 21.2021 14.2163 21.1538C13.9013 21.0568 13.6325 20.8483 13.4604 20.5672L8.94756 13.1098",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSend);
export default __webpack_public_path__ + "static/media/button_send.e413e5242882866ecd744985870fcafa.svg";
export { ForwardRef as ReactComponent };